exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".xclWo {\n  text-align: center;\n  background: #F6F4F0;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  width: 160px;\n}\n.xclWo ._3rf2c {\n  padding-top: 10px;\n  padding-bottom: 20px;\n}\n._2HMrk {\n  padding: 20px 25px;\n}\n", ""]);

// Exports
exports.locals = {
	"menuBar": "xclWo",
	"logo": "_3rf2c",
	"copyright": "_2HMrk"
};